export function getUnifiedLanguageCode(code) {
  let unifiedCode = "";
  try {
    unifiedCode = code.includes("-") ? code.split("-")[0] : code;
  } catch (error) {
    unifiedCode = "en";
  }
  return unifiedCode.toLowerCase();
}
